import { useEffect, useRef } from "react";
import { saveDraft } from "@/lib/draft";

const DEBOUNCE_MS = 1500;

/** Debounced auto-save of any serializable value into localStorage. The
 *  caller decides what to write (typically the form's RHF values). */
export function useDraftAutoSave<T>(values: T, enabled = true) {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (!enabled) return;
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      saveDraft(values);
    }, DEBOUNCE_MS);
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [values, enabled]);
}
